import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef, useState } from 'react';
export function useHeroFlashImgRef() {
  const $ = _c(3);
  const flashRef = useRef(null);
  const [flashMountKey, setFlashMountKey] = useState(0);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = node => {
      const prev = flashRef.current;
      flashRef.current = node;
      if (prev !== node) {
        setFlashMountKey(_temp);
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const setFlashRef = t0;
  let t1;
  if ($[1] !== flashMountKey) {
    t1 = {
      flashRef,
      setFlashRef,
      flashMountKey
    };
    $[1] = flashMountKey;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function _temp(k) {
  return k + 1;
}